import template from './noFinancials.html';
import controller from './noFinancialsCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanScenarioId: '<',
    familyId: '<',
  },
};
